import { Skeleton, Stack } from '@mui/material';

/**
 * Simplified skeleton loader component that mimics a CustomerUploadsListItem
 * Use copilot to update if the actual component changes significantly!
 */
const SkeletonUploadListItem = () => {
  return (
    <Stack
      direction='row'
      justifyContent='space-between'
      alignItems='center'
      sx={{
        padding: 2,
      }}
    >
      {/* Customer name skeleton */}
      <Skeleton
        variant='text'
        width='40%'
        height={24}
        sx={{ borderRadius: '4px' }}
        animation='wave'
      />

      {/* Upload status skeleton */}
      <Skeleton
        variant='text'
        width='20%'
        height={16}
        sx={{ borderRadius: '4px' }}
        animation='wave'
      />
    </Stack>
  );
};

/**
 * Skeleton for the entire uploads list
 * Shows multiple skeleton upload items to represent loading state
 */
export const UploadListSkeleton = ({ numItems = 6 }: { numItems?: number }) => {
  return (
    <Stack
      sx={{
        width: '100%',
        height: '100%',
        overflowY: 'auto',
        mt: 4,
      }}
    >
      {Array.from(new Array(numItems)).map((_, index) => (
        <SkeletonUploadListItem key={index} />
      ))}
    </Stack>
  );
};
